export default function getActicityDeadline(deadline: number) {
  const oneDayTimestamp: number = 24 * 3600 * 1000;
  const nowTimestamp: number = +new Date();
  const diff: number = deadline - nowTimestamp;
  const deadlineDay: number = Math.floor(diff / oneDayTimestamp);

  const hourDiff:number = diff - deadlineDay * oneDayTimestamp;
  const hour: number =  Math.floor(hourDiff / (3600 * 1000));
  const deadlineHour: number | string = hour < 10 ? `0${hour}` : hour;

  const minuteDiff: number = diff - deadlineDay * oneDayTimestamp - hour * 3600 * 1000;
  const minute: number =  Math.floor(minuteDiff / (60 * 1000));
  const deadlineMinute: number | string = minute < 10 ? `0${minute}` : minute;

  const secondDiff: number = diff - deadlineDay * oneDayTimestamp - hour * 3600 * 1000 -minute*60*1000 ;
  const second: number =  Math.floor(secondDiff / 1000);
  const deadlineSecond: number | string = second < 10 ? `0${second}` : second;

  const millisecondDiff: number = diff - deadlineDay * oneDayTimestamp - hour * 3600 * 1000 - minute*60*1000 - second*1000;
  const millisecond: number =  Math.floor(millisecondDiff/10);
  const deadlineMillisecond: number | string = millisecond < 10 ? `0${millisecond}` : millisecond;

  
  return {
    deadlineDay,
    deadlineHour,
    deadlineMinute,
    deadlineSecond,
    deadlineMillisecond
  }
}